const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Maxi Alphabet Stamps
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet',
    name: 'maxi-alphabet-stamps',
    component: ProductList,
    props: {
      title: 'Sets de maxi tampons alphabet',
      description: 'Le grand set alphabet mesure 30mm de haut.',
      tags: ['set-maxi-tampon-alphabet'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/maxi-tampons/margot-maxi-vignette.jpg'),
          name: 'Set de maxi tampons alphabet',
          variant: 'Margot',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet/set-complet-margot-maxi',
        },
        {
          src: require('../../../public/img/materiel-creatif/maxi-tampons/alba-maxi-vignette.jpg'),
          name: 'Set de maxi tampons alphabet',
          variant: 'Alba',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet/set-complet-alba-maxi',
        },
      ],
    },
  },

  // Maxi Margot
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet/set-complet-margot-maxi',
    name: 'full-maxi-set-margot',
    component: () =>
      import('../../pages/products/creative/maxi/Margot/MargotMaxi'),
    props: {
      src: require('../../../public/img/materiel-creatif/maxi-tampons/margot-maxi-vignette.jpg'),
      type: 'Set Margot maxi',
      hiddenType: 'full-maxi-set-margot',
      description: 'Le grand set alphabet mesure 30mm de haut.',
      tags: ['set-complet-margot-maxi'],
    },
  },

  // Maxi Alba
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet/set-complet-alba-maxi',
    name: 'full-maxi-set-alba',
    component: () =>
      import('../../pages/products/creative/maxi/Alba/AlbaMaxi'),
    props: {
      src: require('../../../public/img/materiel-creatif/maxi-tampons/alba-maxi-vignette.jpg'),
      type: 'Set Alba maxi',
      hiddenType: 'full-maxi-set-alba',
      description: 'Le grand set alphabet mesure 30mm de haut.',
      tags: ['set-complet-alba-maxi'],
    },
  },
];
